export const NOTIFICATION_APPOINTMENT_TYPE = "notification-appointment-type";

export default class Notification {
  constructor({ type, data }) {
    this.type = type;
    this.data = data;
  }
}
